import Icon from "./IconBase.js";
const MsTeamIcon = (props) => {
  return (
    <Icon width="24" height="24" viewBox="0 0 24 24" {...props}>
      <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3555 12.5531V20.1966C10.3555 21.1298 10.5844 22.0081 10.9821 22.7859H16.1596C16.8929 22.7859 17.6055 22.0475 17.6055 21.3836V11.4148L17.3144 11.3931H11.5155C10.8744 11.3931 10.3555 11.912 10.3555 12.5531Z"
          fill="black"
        />
        <path
          d="M16.3987 8.28589H13.3164C13.7576 9.67167 15.0398 10.6815 16.5717 10.6815C16.9352 10.6815 17.278 10.61 17.6074 10.5054V9.49457C17.6074 8.82964 17.0636 8.28589 16.3987 8.28589Z"
          fill="black"
        />
        <path
          d="M25.7635 11.3931H20.5922L19.1484 12.5603V18.3489C19.1484 20.498 20.8905 22.2401 23.0396 22.2401C25.1887 22.2401 26.9308 20.498 26.9308 18.3489V12.5603C26.9308 11.9161 26.4078 11.3931 25.7635 11.3931Z"
          fill="#5059C9"
        />
        <path
          d="M25.8934 7.768C25.8934 9.19832 24.7344 10.3573 23.3041 10.3573C21.8738 10.3573 20.7148 9.19832 20.7148 7.768C20.7148 6.33768 21.8738 5.17871 23.3041 5.17871C24.7344 5.17871 25.8934 6.33768 25.8934 7.768Z"
          fill="#5059C9"
        />
        <path
          d="M11.5155 11.3931H20.5883C21.2294 11.3931 21.7483 11.912 21.7483 12.5531V20.1966C21.7483 23.3431 19.1984 25.8931 16.0519 25.8931C12.9054 25.8931 10.3555 23.3431 10.3555 20.1966V12.5531C10.3555 11.912 10.8744 11.3931 11.5155 11.3931Z"
          fill="#7B83EB"
        />
        <path
          d="M20.0004 7.25017C20.0004 9.14553 18.4644 10.6815 16.5691 10.6815C14.6737 10.6815 13.1367 9.14553 13.1367 7.25017C13.1367 5.35481 14.6737 3.81885 16.5691 3.81885C18.4644 3.81885 20.0004 5.35481 20.0004 7.25017Z"
          fill="#7B83EB"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3147 8.28564H16.397C17.0619 8.28564 17.6057 8.82939 17.6057 9.49432V10.5052C17.2763 10.6098 16.9335 10.6813 16.5699 10.6813C15.0381 10.6813 13.7559 9.67143 13.3147 8.28564ZM10.3555 20.1965V12.5529C10.3555 11.9118 10.8744 11.3929 11.5155 11.3929H17.3144L17.6055 11.4147V21.3834C17.6055 22.0473 16.8929 22.7858 16.1596 22.7858H10.9821C10.5844 22.008 10.3555 21.1297 10.3555 20.1965Z"
          fill="black"
        />
        <path
          d="M15.3616 21.75H3.27796C2.61406 21.75 2.07031 21.2063 2.07031 20.5413V8.45868C2.07031 7.79375 2.61406 7.25 3.27796 7.25H15.3616C16.0266 7.25 16.5703 7.79375 16.5703 8.45868V20.5413C16.5703 21.2063 16.0266 21.75 15.3616 21.75Z"
          fill="#4B53BC"
        />
        <path
          d="M12.6155 11.991H10.1412V18.6424H8.51513V11.991H6.02734V10.3567H12.6155V11.991Z"
          fill="white"
        />
      </svg>
    </Icon>
  );
};
export default MsTeamIcon;
